export const CONSUMER_PREMIUM_SUBSCRIPTION = 'consumer-premium'
export const CONSUMER_PREMIUM_SUBSCRIPTION_LIST = ['consumer-developer', 'consumer-premium']
